import { Assignment } from "./assignment";
import { Employee } from "./employee";
import { Product } from "./product";

export class EmployeeAvailable extends Employee {
    price!: number
    discount!: number
    availability: any[] = []
    products: Product[] = []
    override assignments: Assignment[] = []
    badges: any[] = []
}
